<template>
<div class="row">
	<div class="col-12">
		<table style="width: 100%" class="table table-hover table-bordered table-sm table-striped">
			<thead>
				<tr>
					<th>Configuração</th>
					<th class="text-center">Valor</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in Object.keys(config)" :key="index">
					<td>{{item}}</td>
					<td class="text-center">{{config[item]}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
</template>

<script>
export default {

	props: ['config']
}
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/posicao/posicao-config.vue